import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TitlebarBelowMasonryImageList from './TitlebarBelowMasonryImageList';
import ClientProvider from './client';
export default createDemo(import.meta.url, TitlebarBelowMasonryImageList, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/image-list/demos/titlebar-below-masonry/TitlebarBelowMasonryImageList.tsx",
    "fileName": "TitlebarBelowMasonryImageList.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport ImageList from '@mui/material/ImageList';\nimport ImageListItem from '@mui/material/ImageListItem';\nimport ImageListItemBar from '@mui/material/ImageListItemBar';\n\nexport default function TitlebarBelowMasonryImageList() {\n  return (\n    <Box sx={{ width: 500, height: 450, overflowY: 'scroll' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ImageList variant=\"masonry\" cols={3} gap={8}>\n        {itemData.map((item) => (\n          <ImageListItem key={item.img}>\n            <img\n              srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}\n              src={`${item.img}?w=248&fit=crop&auto=format`}\n              alt={item.title}\n              loading=\"lazy\"\n            />\n            <ImageListItemBar position=\"below\" title={item.author} />\n          </ImageListItem>\n        ))}\n      </ImageList>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n\nconst itemData = [\n  {\n    img: 'https://images.unsplash.com/photo-1549388604-817d15aa0110',\n    title: 'Bed',\n    author: 'swabdesign',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1525097487452-6278ff080c31',\n    title: 'Books',\n    author: 'Pavel Nekoranec',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1523413651479-597eb2da0ad6',\n    title: 'Sink',\n    author: 'Charles Deluvio',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1563298723-dcfebaa392e3',\n    title: 'Kitchen',\n    author: 'Christian Mackie',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1588436706487-9d55d73a39e3',\n    title: 'Blinds',\n    author: 'Darren Richardson',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1574180045827-681f8a1a9622',\n    title: 'Chairs',\n    author: 'Taylor Simpson',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1530731141654-5993c3016c77',\n    title: 'Laptop',\n    author: 'Ben Kolde',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1481277542470-605612bd2d61',\n    title: 'Doors',\n    author: 'Philipp Berndt',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1517487881594-2787fef5ebf7',\n    title: 'Coffee',\n    author: 'Jen P.',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1516455207990-7a41ce80f7ee',\n    title: 'Storage',\n    author: 'Douglas Sheppard',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1597262975002-c5c3b14bbd62',\n    title: 'Candle',\n    author: 'Fi Bell',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1519710164239-da123dc03ef4',\n    title: 'Coffee table',\n    author: 'Hutomo Abrianto',\n  },\n];\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 87,
        "focusedLines": 13,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport ImageList from '@mui/material/ImageList';\nimport ImageListItem from '@mui/material/ImageListItem';\nimport ImageListItemBar from '@mui/material/ImageListItemBar';\n\nexport default function TitlebarBelowMasonryImageList() {\n  return (\n    <Box sx={{ width: 500, height: 450, overflowY: 'scroll' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ImageList variant=\"masonry\" cols={3} gap={8}>\n        {itemData.map((item) => (\n          <ImageListItem key={item.img}>\n            <img\n              srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}\n              src={`${item.img}?w=248&fit=crop&auto=format`}\n              alt={item.title}\n              loading=\"lazy\"\n            />\n            <ImageListItemBar position=\"below\" title={item.author} />\n          </ImageListItem>\n        ))}\n      </ImageList>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n\nconst itemData = [\n  {\n    img: 'https://images.unsplash.com/photo-1549388604-817d15aa0110',\n    title: 'Bed',\n    author: 'swabdesign',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1525097487452-6278ff080c31',\n    title: 'Books',\n    author: 'Pavel Nekoranec',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1523413651479-597eb2da0ad6',\n    title: 'Sink',\n    author: 'Charles Deluvio',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1563298723-dcfebaa392e3',\n    title: 'Kitchen',\n    author: 'Christian Mackie',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1588436706487-9d55d73a39e3',\n    title: 'Blinds',\n    author: 'Darren Richardson',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1574180045827-681f8a1a9622',\n    title: 'Chairs',\n    author: 'Taylor Simpson',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1530731141654-5993c3016c77',\n    title: 'Laptop',\n    author: 'Ben Kolde',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1481277542470-605612bd2d61',\n    title: 'Doors',\n    author: 'Philipp Berndt',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1517487881594-2787fef5ebf7',\n    title: 'Coffee',\n    author: 'Jen P.',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1516455207990-7a41ce80f7ee',\n    title: 'Storage',\n    author: 'Douglas Sheppard',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1597262975002-c5c3b14bbd62',\n    title: 'Candle',\n    author: 'Fi Bell',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1519710164239-da123dc03ef4',\n    title: 'Coffee table',\n    author: 'Hutomo Abrianto',\n  },\n];\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageList"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "masonry",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "cols"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "3"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "gap"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "8"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "itemData"
              ],
              ".",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "item"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageListItem"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "img"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "            <",
              [
                "span",
                "pl-ent",
                "img"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "              ",
              [
                "span",
                "pl-e di-ak",
                "srcSet"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ],
                  [
                    "span",
                    "di-te",
                    [
                      [
                        "span",
                        "di-td",
                        "${"
                      ],
                      [
                        "span",
                        "pl-smi",
                        "item"
                      ],
                      ".",
                      [
                        "span",
                        "pl-smi",
                        "img"
                      ],
                      [
                        "span",
                        "di-td",
                        "}"
                      ]
                    ]
                  ],
                  "?w=248&fit=crop&auto=format&dpr=2 2x",
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "              ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ],
                  [
                    "span",
                    "di-te",
                    [
                      [
                        "span",
                        "di-td",
                        "${"
                      ],
                      [
                        "span",
                        "pl-smi",
                        "item"
                      ],
                      ".",
                      [
                        "span",
                        "pl-smi",
                        "img"
                      ],
                      [
                        "span",
                        "di-td",
                        "}"
                      ]
                    ]
                  ],
                  "?w=248&fit=crop&auto=format",
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "              ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-c1 di-jv",
                "title"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "              ",
              [
                "span",
                "pl-e di-ak",
                "loading"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "lazy",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            "            />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "            <",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageListItemBar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "position"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "below",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "title"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "author"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageListItem"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageList"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 87,
    "focusedLines": 13,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/ImageList",
      "@mui/material/ImageListItem",
      "@mui/material/ImageListItemBar"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
